"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _formElements = require("@evidation/form-elements");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var CollapsibleContainer = _styledComponents["default"].details.withConfig({
  displayName: "hintText__CollapsibleContainer"
})(["margin:8px 0 8px 0;color:#5e5e5e;font-weight:400;font-size:16px;& *{color:#5e5e5e;font-weight:400;font-size:16px;line-height:24px;}"]);
var BaseContainer = _styledComponents["default"].div.withConfig({
  displayName: "hintText__BaseContainer"
})(["margin:8px 0 8px 0;color:#5e5e5e;font-weight:400;font-size:16px;& *{color:#5e5e5e;font-weight:400;font-size:16px;line-height:24px;}"]);
var HintText = function HintText(_ref) {
  var text = _ref.text,
    _ref$collapsible = _ref.collapsible,
    collapsible = _ref$collapsible === void 0 ? false : _ref$collapsible,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'id_hint_text' : _ref$id;
  return collapsible ?
  /*#__PURE__*/
  // class name added to apply styles through custom branding css
  _react["default"].createElement(CollapsibleContainer, {
    className: "text_hint",
    id: id
  }, /*#__PURE__*/_react["default"].createElement("summary", null, "Hint"), /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, text)) :
  /*#__PURE__*/
  // class name added to apply styles through custom branding css
  _react["default"].createElement(BaseContainer, {
    className: "text_hint",
    id: id
  }, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, text));
};
var _default = exports["default"] = HintText;